import { getMPDataWithParams } from 'src/mentor/services'

/**
 * Practitioner-self roster + presence APIs (the logged-in practitioner viewing their own roster).
 * These mirror the support-portal roster endpoints but are self-scoped:
 *   - GET /api/secure/mentor/my-roster
 *   - GET /api/secure/teacher/my-clinic-associations/usage-logs
 * Both accept optional clinicLocationIds (CSV) so the view can be scoped to one clinic location
 * ("this clinic") or left unfiltered ("all clinics").
 */

const csv = (value) => {
  if (Array.isArray(value)) {
    const joined = value.filter(Boolean).join(',')
    return joined || undefined
  }
  return value || undefined
}

export async function getMyRoster({
  fromDate,
  toDate,
  clinicLocationIds,
  clinicBrandIds,
  includeBookedSlots = true,
}) {
  return getMPDataWithParams('/api/secure/mentor/my-roster', {
    fromDate,
    toDate,
    clinicLocationIds: csv(clinicLocationIds),
    clinicBrandIds: csv(clinicBrandIds),
    includeBookedSlots,
  })
}

export async function getMyEmrUsageLogs({ fromDate, toDate, clinicLocationIds, logEventIds }) {
  return getMPDataWithParams('/api/secure/teacher/my-clinic-associations/usage-logs', {
    fromDate,
    toDate,
    clinicLocationIds: csv(clinicLocationIds),
    logEventIds: csv(logEventIds),
  })
}

/** Pull the roster-slots array out of the various CommonResponse shapes the API may use. */
export function extractRosterSlots(resp) {
  const d = resp?.data
  const slots =
    d?.data?.rosterSlots ||
    d?.payload?.rosterSlots ||
    d?.rosterSlots ||
    d?.data?.rosterSlotViews ||
    d?.data ||
    d?.payload ||
    []
  return Array.isArray(slots) ? slots : []
}

/** Pull the usage-logs array out of the various CommonResponse shapes the API may use. */
export function extractUsageLogs(resp) {
  const d = resp?.data
  const logs = d?.data?.usageLogs || d?.usageLogs || d?.data?.emrUsageLogs || d?.payload?.usageLogs || []
  return Array.isArray(logs) ? logs : []
}
